import React from 'react';
import { Megaphone, ArrowRight, Mail } from 'lucide-react';

const MAILTO =
  'mailto:Support@Novareelhub.com?subject=Advertise%20With%20Us%20on%20NovaReelTV&body=Hi%20NovaReelTV%20team%2C%0D%0A%0D%0AI%27d%20like%20to%20learn%20more%20about%20advertising%20on%20NovaReelTV.%0D%0A%0D%0ACompany%3A%0D%0AWebsite%3A%0D%0ABudget%3A%0D%0AGoal%3A%0D%0A%0D%0AThanks%21';

/**
 * AdvertiseWithUs — a visually distinct CTA linking to Support@Novareelhub.com.
 *
 * Variants:
 *  - "pill"   Small inline badge suitable for tight spots (next to "Sponsored" labels).
 *  - "card"   Full-width banner suitable for the login page and between movie rows.
 *  - "floating"  Fixed, right-side pinned pill.
 */
const AdvertiseWithUs = ({ variant = 'card', className = '' }) => {
  if (variant === 'pill') {
    return (
      <a
        href={MAILTO}
        data-testid="advertise-cta"
        className={`inline-flex items-center gap-1.5 text-[10px] md:text-xs font-semibold uppercase tracking-widest px-2.5 py-1 rounded-full bg-white/10 border border-white/20 text-white hover:bg-[#e11d48] hover:border-[#e11d48] transition-colors ${className}`}
      >
        <Megaphone className="w-3 h-3" /> Advertise with us
      </a>
    );
  }

  if (variant === 'floating') {
    return (
      <a
        href={MAILTO}
        data-testid="advertise-cta"
        className={`fixed left-5 bottom-5 z-[64] hidden md:inline-flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-amber-400 to-[#e11d48] shadow-2xl hover:scale-105 active:scale-95 transition-transform ${className}`}
      >
        <Megaphone className="w-4 h-4" /> Advertise with us
      </a>
    );
  }

  // "card" (default)
  return (
    <a
      href={MAILTO}
      data-testid="advertise-cta"
      className={`group relative block overflow-hidden rounded-xl border border-white/10 hover:border-white/25 transition-colors ${className}`}
    >
      <div className="relative bg-gradient-to-r from-amber-400 via-[#e11d48] to-[#7f1d1d] px-5 md:px-8 py-5 md:py-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-full bg-white/15 flex items-center justify-center shrink-0">
            <Megaphone className="w-5 h-5 text-white" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-white/80 font-semibold">Sponsor NovaReelTV</div>
            <div className="text-white text-lg md:text-2xl font-extrabold leading-tight">
              Put your brand in front of movie lovers.
            </div>
            <div className="text-white/85 text-xs md:text-sm mt-0.5">
              Home banners, sponsorship slots, custom placements — starting from just{' '}
              <span className="font-semibold">$99/week</span>.
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 md:justify-end">
          <span className="hidden md:inline-flex items-center gap-1 text-xs text-white/90 bg-black/20 rounded-full px-2.5 py-1">
            <Mail className="w-3.5 h-3.5" /> Support@Novareelhub.com
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white text-[#e11d48] font-semibold text-sm px-4 py-2 rounded-md group-hover:bg-white/90 transition-colors">
            Advertise with us <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </div>
    </a>
  );
};

export default AdvertiseWithUs;
